import React from "react";
import { Box, Container, Typography } from "@material-ui/core";

import AauReverificationTool from "./AauReverificationTool";
import EventOrderTool from "./EventOrderTool";
import UnfinalizeEventTool from "./UnfinalizeEventTool";
import { PAGES_TITLES } from "../../constants/titles";
import { useToolStyles } from "./styles";

/** One-off maintenance jobs that used to need an SQL script. System admins only. */
const Tools = () => {
  const classes = useToolStyles();
  return (
    <Box className={classes.page}>
      <Container maxWidth="xl">
        <Typography component="h1" className={classes.title}>
          {PAGES_TITLES.TOOLS}
        </Typography>
        <Typography className={classes.subtitle}>
          Maintenance jobs for system administrators. Each one previews or dry
          runs first, and asks before it changes anything.
        </Typography>
        <AauReverificationTool />
        <EventOrderTool />
        <UnfinalizeEventTool />
      </Container>
    </Box>
  );
};

export default Tools;
